import React from 'react';
import styled from 'styled-components';
import EsApplyProdCateContainer from './EsApplyProdCateContainer';
import Cate3DepListContainer from '../common/Cate3DepListContainer';
import CateFilterContainer from '../common/CateFilterContainer';
import CateProdContiner from '../common/CateProdContiner';
import PriceFilterContainer from '../common/PriceFilterContainer';


const EsProdContainerBlock = styled.div``;

const EsProdTopLineBlock = styled.div`
    border-top: 2px solid #111;
`;

const EsProdWrapBlock = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

/**
 * 견적 - 상품 섹션의 네트워크 처리 
 * 카테고리 정보와 필터 상품 정보 각각 다른 API를 사용하므로 container 분리 처리 
 */
const EsApplyProdContainer = ({ evtHandler }) => {

    // 다음 버튼 선택 처리
    const handleNextBtnClick = () => {
        evtHandler(true);
    }

    // 이전 버튼 선택 처리
    const handlePrevBtnClick = () => {
        evtHandler(false);
    }

    // console.log("EsApplyProdContainer ------>")
    return (
        <EsProdContainerBlock>
            <EsApplyProdCateContainer />

            <div className="aa-btm">

                <div className="tag_filter-wrap margin_b-40">
                    <div className="filter-top myes_top clearfix">
                        <div className="filter-fc f-right">
                            <button type="button" className="reset-btn">초기화</button>
                        </div>
                    </div>
                    <EsProdTopLineBlock>
                        <EsProdWrapBlock>
                            <Cate3DepListContainer />
                            {/* <CateFilterContainer /> */}
                            <PriceFilterContainer />
                        </EsProdWrapBlock>
                    </EsProdTopLineBlock>
                </div>

                <CateProdContiner />

                <div className="text_center">
                    <button type="button" id="prodApplyPrevBtn" className="s-btn gray-btn" onClick={handlePrevBtnClick}>이전</button>
                    <button type="button" id="prodApplyNextBtn" className="s-btn black-btn margin_l-30" onClick={handleNextBtnClick}>다음</button>
                </div>
            </div>
        </EsProdContainerBlock>
    );
};

export default EsApplyProdContainer;